var map = {
	"./text-and-image-row/input.component.tsx": 2798,
	"./text-and-image-row/section.component.tsx": 6220
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6219;


//////////////////
// WEBPACK FOOTER
// ./src/template/sections/content ^\.\/.*\.component\.tsx$
// module id = 6219
// module chunks = 0